import React, { Component } from "react";
// react component that creates a form divided into multiple steps
import StepZilla from "react-stepzilla";
import { Grid, Row, Col } from "react-bootstrap";

import Card from "../../../components/Card/Card.jsx";
import * as loginActions from '../../../actions/loginActions';
import * as consentActions from '../../../actions/consentActions';

import Artists_Step1 from "./Artists_Step1.jsx";
import Clauses_Step2 from "./Clauses_Step2.jsx";
import Personal_Step3 from "./Personal_Step3.jsx";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import rest from "../../../API/api";
import ReactDOM from "react-dom";


class ConsentFormWizard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: this.props.consent.id,
            Enabled: this.props.consent.Enabled,
            Name: this.props.consent.Name,
            Header: this.props.consent.Header,
            AfterSubmit: this.props.consent.AfterSubmit,
            TitleImage: this.props.consent.TitleImage,
            Company:  this.props.consent.Company,
            EmailTo:  this.props.consent.EmailTo,
            EmailFrom: this.props.consent.EmailFrom,
            EmailSubject: this.props.consent.EmailSubject,
            EmailText: this.props.consent.EmailText,
            EnableCamera: this.props.consent.EnableCamera,
            PhotoRequired: this.props.consent.PhotoRequired,
            AgeLimit: this.props.consent.AgeLimit,
            AskRelation: this.props.consent.AskRelation ,
            EnableNotary: this.props.consent.EnableNotary,
            ParentHeader: this.props.consent.ParentHeader,
            ConsentFooter: this.props.consent.ConsentFooter,
            RequireName: this.props.consent.RequireName,
            RequireAddress: this.props.consent.RequireAddress,
            RequireEmail: this.props.consent.RequireEmail,
            RequirePhone: this.props.consent.RequirePhone,
            RequireNationality: this.props.consent.RequireNationality,
            RequireGender: this.props.consent.RequireGender,
            dataClauses: this.props.consent.IncludedClauses,
            dataArtists: this.props.consent.IncludedArtists,
        };
        //Lets load the consent form settings using the consent form id passed as a parameter, this is done via
        //redux store
        this.props.consentActions.readConsent(this.props.userLoggedIn[0],this.props.id);
        this.consentSubmission = {
            //These are the fields that I need to store for the consent submission not the consent form settings
            consentDate: "",
            consentArtist: "",
            consentClauses: [],
            consentClausesStatus: [],
            consentName: "",
            consentAddress: "",
            consentPhone: "",
            consentEmail: "",
            consentNationality: "",
            consentGender: "",
            consentDoB: "",
            consentPhotoId:"",
            consentAge: "",
            consentOldEnough: false,
            consentParentConsentNeeded: false,
            consentSignature:  "",
            consentGuardianName: "",
            consentGuardianRelation: "",
            consentGuardianSignature: "",
            consentNotes: "",
            consentFooter: "",
            savedConsent: false,
        };


        //this.props.consentActions.readConsent(this.props.id);
    }

    componentDidMount() {
    }


    componentWillUnmount() {}

    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }


   //Will use local store to keep items entered on this submission
    getStore() {
        return this.consentSubmission;
    }

    updateStore(update) {
        this.consentSubmission = {
            ...this.consentSubmission,
            ...update,
        }
    }

    //This is used on final step to clear the last submission when the wizard is started over.
    clearStore(){
        var consentSubmission = {
            //These are the fields that I need to store for the consent submission not the consent form settings
            consentDate: "",
            consentArtist: "",
            consentClauses: [],
            consentClausesStatus: [],
            consentName: "",
            consentAddress: "",
            consentPhone: "",
            consentEmail: "",
            consentNationality: "",
            consentGender: "",
            consentDoB: "",
            consentPhotoId:"",
            consentAge: "",
            consentOldEnough: false,
            consentParentConsentNeeded: false,
            consentSignature:  "",
            consentGuardianName: "",
            consentGuardianRelation: "",
            consentGuardianSignature: "",
            consentNotes: "",
            consentFooter: "",
            savedConsent: false,
        };
        this.updateStore(consentSubmission)
    }

    render() {
        if (((this.props.userLoggedIn[0].status) || (this.props.userLoggedIn[0].role === "Kiosk")) && (this.props.userLoggedIn[0].subscription)) {
            this.updateStore(this.props.consent);
            const steps = [
                {
                    name: "Who is your artist Today?",
                    component: <Artists_Step1 getStore={() => (this.getStore())} updateStore={(u) => {
                        this.updateStore(u)
                    }} consentSubmission={this.consentSubmission}/>
                },
                {
                    name: "Consent Clauses",
                    component: <Clauses_Step2 getStore={() => (this.getStore)} updateStore={(u) => {
                        this.updateStore(u)
                    }} consentSubmission={this.consentSubmission}/>
                },
                {
                    name: "Personal Information & Photo ID", component: <Personal_Step3
                        getStore={() => (this.getStore())}
                        updateStore={(u) => {
                            this.updateStore(u)
                        }}
                        clearStore={() => {
                            this.clearStore()
                        }}
                        consentSubmission={this.consentSubmission}
                        userRole ={this.props.userLoggedIn[0].role}
                        userId ={this.props.userLoggedIn[0]._id}
                        tenant={this.props.userLoggedIn[0]}

                    />
                },
            ];
            return (
                <div className="main-content"
                     style={{backgroundImage: "url(" + require("../../../assets/img/matrix.jpg") + ")"}}>
                    <Grid fluid>
                        <Row>
                            <Col md={10} mdOffset={1}>
                                <Card
                                    wizard
                                    id="wizardCard"
                                    textCenter
                                    title={this.getStore().Header}
                                    category="Lets get the legal stuff done so we can get to work!"
                                    content={
                                        <StepZilla
                                            steps={steps}
                                            stepsNavigation={false}
                                            dontValidate={false}
                                            nextButtonCls="btn btn-prev btn-info btn-fill pull-right btn-wd"
                                            backButtonCls="btn btn-next btn-default btn-fill pull-left btn-wd"
                                        />
                                    }
                                />
                            </Col>
                        </Row>
                    </Grid>
                </div>
            );
        }
        else {
            alert("You must be logged in and have an active subscription to access this page!");
            this.context.router.history.push("/pages/login-page");
            return(null);
        }

  }
}

function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;
    return {
        userLoggedIn: state.userLoggedIn,
        consent: state.consent,
        id: id
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        consentActions: bindActionCreators(consentActions, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ConsentFormWizard);

//export default Wizard;



// WEBPACK FOOTER //
// ./src/views/Forms/DisplayConsentFormWizard/DisplayConsentWizard.jsx